











import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class HorizontalList extends Vue {
  @Prop(String) private title: string;
  @Prop(String) private color: string;

  constructor() {
    super();
  }
}
